"use client";

import React, { useState, useEffect } from "react";
import Sketch from "react-p5";
import p5Types from "p5";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DemoIntroduction() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.createCanvas(p5.windowWidth, p5.windowHeight).parent(canvasParentRef);
    p5.frameRate(60);
  };
  const draw = (p5: p5Types) => {
    p5.clear();
    p5.noFill();
    const t = p5.frameCount * 0.01;
    for (let i = 0; i < 5; i++) {
      p5.strokeWeight(2 + i * 0.5);
      const alpha = p5.map(i, 0, 5, 100, 20);
      p5.stroke(80, 70, 229, alpha);
      p5.beginShape();
      for (let x = 0; x <= p5.width; x += 20) {
        const y = p5.height / 2 + p5.sin(x * 0.005 + t + i * 0.5) * 100 * p5.noise(t * 0.5, i) + p5.cos(x * 0.01 - t) * 50;
        p5.vertex(x, y);
      }
      p5.endShape();
    }
  };
  const windowResized = (p5: p5Types) => {
    p5.resizeCanvas(p5.windowWidth, p5.windowHeight);
  };
  return <section id="demo-introduction" className="relative w-full overflow-hidden bg-secondary py-32">
      {}
      {isMounted && <div className="absolute inset-0 z-0 opacity-60 blur-[10px] pointer-events-none">
          <Sketch setup={setup} draw={draw} windowResized={windowResized} />
        </div>}

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div ref={textRef} className={`transition-all duration-1000 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <h1 className="font-sans font-black text-5xl md:text-7xl leading-[1.1] tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-foreground to-primary mb-8 max-w-5xl mx-auto">
            Experience the Future of Voice
          </h1>

          {}
          <p className="font-sans font-light text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto mb-12 leading-relaxed">
            See our AI agents in action. Interact with intelligent voice technology that understands context, emotion, and intent in real-time.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="h-14 px-8 text-lg rounded-full shadow-lg hover:shadow-primary/25 transition-all duration-300">
              <Link to="#demo-form">
                Start Live Demo
                <Play className="ml-2 size-5 fill-current" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-full border-primary/20 hover:bg-primary/5 hover:text-primary transition-all duration-300">
              <Link to="/SolutionsPage">
                Explore Solutions
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}